import { Dataset, Lead } from '../types';
import { TOUR_SAMPLE_DATA } from './tour';

export const TOUR_MOCK_DATASET: Dataset = {
  id: TOUR_SAMPLE_DATA.datasetId,
  name: TOUR_SAMPLE_DATA.datasetName,
  description: 'YC-funded AI startups that raised Series A',
  created_at: new Date().toISOString(),
  updated_at: new Date().toISOString(),
  table_type: 'companies',
  lead_count: 5,
  status: 'completed',
  user_prompt: 'YC-funded AI startups that raised Series A',
};

// Criteria names that will become column headers
const CRITERIA = {
  YC_FUNDED: 'YC-funded',
  AI_STARTUP: 'AI startup',
  SERIES_A: 'Raised Series A',
};

const mockReasoning = (criterionText: string, satisfied: 'yes' | 'no' | 'partial', reasoning: string, sources: string[]) => ({
  criterion_text: criterionText,
  reasoning_text: reasoning,
  satisfied,
  source_urls: sources,
});

// All companies below are actual YC-funded AI startups
export const TOUR_MOCK_LEADS: Lead[] = [
  {
    id: 'tour-lead-1',
    type: 'company',
    name: 'OpenAI',
    data: { Name: 'OpenAI', URL: 'https://openai.com', Description: 'AI research lab building safe AGI systems including ChatGPT and GPT-4.' },
    reasoning: {
      'yc-funded': mockReasoning(CRITERIA.YC_FUNDED, 'yes', 'OpenAI was part of Y Combinator\'s W16 batch, founded by Sam Altman who was YC president.', ['https://www.ycombinator.com/companies/openai']),
      'ai-startup': mockReasoning(CRITERIA.AI_STARTUP, 'yes', 'OpenAI is a leading AI research company known for ChatGPT, GPT-4, and DALL-E.', ['https://openai.com/about']),
      'series-a': mockReasoning(CRITERIA.SERIES_A, 'yes', 'OpenAI raised over $1B in early funding rounds including Series A from Microsoft.', ['https://openai.com/blog/microsoft-invests-in-openai']),
    },
    createdAt: new Date(),
  },
  {
    id: 'tour-lead-2',
    type: 'company',
    name: 'Scale AI',
    data: { Name: 'Scale AI', URL: 'https://scale.com', Description: 'Data platform for AI providing high-quality training data and evaluation.' },
    reasoning: {
      'yc-funded': mockReasoning(CRITERIA.YC_FUNDED, 'yes', 'Scale AI was part of Y Combinator\'s S16 batch.', ['https://www.ycombinator.com/companies/scale-ai']),
      'ai-startup': mockReasoning(CRITERIA.AI_STARTUP, 'yes', 'Scale AI provides data labeling and AI infrastructure for machine learning teams.', ['https://scale.com/about']),
      'series-a': mockReasoning(CRITERIA.SERIES_A, 'yes', 'Scale AI raised $100M Series C in 2021, having previously raised Series A and B.', ['https://techcrunch.com/2021/04/13/scale-ai-raises-100m/']),
    },
    createdAt: new Date(),
  },
  {
    id: 'tour-lead-3',
    type: 'company',
    name: 'Hugging Face',
    data: { Name: 'Hugging Face', URL: 'https://huggingface.co', Description: 'Open-source AI platform and community hub for machine learning models.' },
    reasoning: {
      'yc-funded': mockReasoning(CRITERIA.YC_FUNDED, 'yes', 'Hugging Face graduated from Y Combinator\'s W17 batch.', ['https://www.ycombinator.com/companies/hugging-face']),
      'ai-startup': mockReasoning(CRITERIA.AI_STARTUP, 'yes', 'Hugging Face is the leading open-source platform for AI/ML with 500k+ models.', ['https://huggingface.co/about']),
      'series-a': mockReasoning(CRITERIA.SERIES_A, 'yes', 'Hugging Face raised $40M Series B in 2022 after completing Series A.', ['https://huggingface.co/blog/series-b']),
    },
    createdAt: new Date(),
  },
  {
    id: 'tour-lead-4',
    type: 'company',
    name: 'Labelbox',
    data: { Name: 'Labelbox', URL: 'https://labelbox.com', Description: 'Data-centric AI platform for creating and managing training data.' },
    reasoning: {
      'yc-funded': mockReasoning(CRITERIA.YC_FUNDED, 'yes', 'Labelbox was part of Y Combinator\'s W18 batch.', ['https://www.ycombinator.com/companies/labelbox']),
      'ai-startup': mockReasoning(CRITERIA.AI_STARTUP, 'yes', 'Labelbox builds AI training data infrastructure used by ML teams worldwide.', ['https://labelbox.com/about']),
      'series-a': mockReasoning(CRITERIA.SERIES_A, 'yes', 'Labelbox raised $40M Series B in 2020, having raised Series A in 2019.', ['https://labelbox.com/blog/series-b']),
    },
    createdAt: new Date(),
  },
  {
    id: 'tour-lead-5',
    type: 'company',
    name: 'Weights & Biases',
    data: { Name: 'Weights & Biases', URL: 'https://wandb.ai', Description: 'MLOps platform for experiment tracking and model management.' },
    reasoning: {
      'yc-funded': mockReasoning(CRITERIA.YC_FUNDED, 'yes', 'Weights & Biases (W&B) was part of Y Combinator\'s W18 batch.', ['https://www.ycombinator.com/companies/weights-biases']),
      'ai-startup': mockReasoning(CRITERIA.AI_STARTUP, 'yes', 'W&B provides ML experiment tracking and model registry used by OpenAI, NVIDIA, and others.', ['https://wandb.ai/about']),
      'series-a': mockReasoning(CRITERIA.SERIES_A, 'yes', 'W&B raised $45M Series B in 2021 after completing Series A.', ['https://wandb.ai/blog/series-b']),
    },
    createdAt: new Date(),
  },
];

export const TOUR_MOCK_COLUMNS = ['Name', 'URL', 'Description'];

export const getTourMockData = () => ({
  dataset: TOUR_MOCK_DATASET,
  leads: TOUR_MOCK_LEADS,
  columns: TOUR_MOCK_COLUMNS,
});
